import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectableSupplierAccount = QueryHookResult<
  typeof useSupplierAccountsQuery
>[number];

export const useSupplierAccountsQuery = createQueryHook(
  'shared.selectSupplierAccount',
  (params: { searchTerm?: string; ids?: string[] }) => ({
    accounts: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          isSupplier: true,
        },
        pagination: {
          offset: 0,
          limit: 20,
        },
      },
      entries: {
        id: true,
        name: true,
        type: true,
        email: true,
        phone: true,
      },
    },
  }),
  {
    select: (data) => data.accounts.entries ?? [],
  },
);

export const SelectSupplierAccount = createEntityComboBox.remotelySearched(
  'SelectSupplierAccount',
  useSupplierAccountsQuery,
  {
    formatLabel: (entity) => entity.name,
    formatSubLabel: (entity) => entity.email ?? '',
    formatGroup: (entity) => entity.type,
  },
);
